import { Schema, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { schemaClient, SchemaPathParameters } from './SchemaClient';

const factory = createStudyEntityHookFactory<Schema, SchemaPathParameters>(StudyEntityType.Schema);
export const useSchemas = factory.list(schemaClient.list);
export const useSchema = factory.get(schemaClient.get);
export const useCreateSchema = factory.mutate(schemaClient.create);
export const useUpdateSchema = factory.mutate(schemaClient.update);
export const useDeleteSchema = factory.mutate(schemaClient.delete);
